export { default as analyticsWebClientForSSR } from './ssr-mock-client';
